<template>
    <form-group
        v-bind="form_group_props"
    >
        <template v-slot:read_only><slot name="read_only"></slot></template>
        <template v-slot:empty-value><slot name="empty-value"></slot></template>
        <template v-slot:label><slot name="label"></slot></template>
        <template v-slot:required="{ required }"><slot name="required" :required="required"></slot></template>
        <template v-slot:hint><slot name="hint"></slot></template>
        <div class="columns">
            <div
                v-for="option in options"
                :key="option.id"
                class="column col-sm-12 col-md-6"
            >
                <default-toggle-input
                    type="checkbox"
                    :id="`${id}-${option.id}`"
                    :name="name"
                    :value="!!(value & option.id)"
                    :size="size"
                    :aria-describedby="!!has_slot('hint') ? `${identifier}-description` : false"
                    :disabled="!editable || disabled"
                    @input="toggle_bitwise(option.id)"
                >
                    {{ option.name }}
                </default-toggle-input>
            </div>
        </div>
    </form-group>
</template>

<script type="text/javascript">
import is_nibnut_component from "@/nibnut/mixins/IsNibnutComponent"

import FormGroup from "@/nibnut/components/Inputs/FormGroup"
import DefaultToggleInput from "@/nibnut/components/Inputs/DefaultToggleInput"

export default {
    name: "FormBitwiseInput",
    mixins: [is_nibnut_component],
    components: {
        FormGroup,
        DefaultToggleInput
    },
    methods: {
        toggle_bitwise (value) {
            let result = this.value
            if(result & value) result ^= value
            else result |= value
            this.$emit("input", result, this.name)
        }
    },
    computed: {
        form_group_props () {
            return {
                id: this.id,
                name: this.name,
                value: this.value,
                required: false,
                editable: this.editbale,
                error: this.error,
                waiting: this.saving
            }
        }
    },
    props: {
        ...DefaultToggleInput.props,
        options: {
            type: Array,
            default () {
                return []
            }
        },
        disabled: { // disable input field
            type: Boolean,
            default: false
        },
        editable: { // read-only
            type: Boolean,
            default: true
        },
        saving: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ""
        }
    }
}
</script>
